<template>
	<div class="spouse-detail-form">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form role="form" class="mt-4" @submit.prevent="submit">
				<b-row>
					<b-col md="8" cols="12">
						<b-form-group label="Spouse Name">
							<ValidationProvider v-slot="{ errors }" :rules="{ name: true }" :vid="'spouseName'">
								<b-form-input v-model="form.spouse.name" type="text" placeholder="Enter spouse name"></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Spouse NRIC">
							<ValidationProvider v-slot="{ errors }" :rules="{ number_only: true, nric: true, nric_check:true }" :vid="'nric'">
								<b-form-input v-model="form.spouse.nric" type="text" placeholder="Enter spouse nric"
									maxlength="12"></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Spouse Contact No.">
							<ValidationProvider v-slot="{ errors }" :rules="{ number_only: true }" :vid="'number_only'">
								<b-form-input v-model="form.spouse.contact_no" type="text" maxlength="17"
									placeholder="Enter Spouse contact number" @keydown="preventNonNumericInput">
								</b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Spouse company Name">
							<b-form-input v-model="form.spouse.company_name" type="text"
								placeholder="Enter spouse company name"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Spouse Position">
							<b-form-input v-model="form.spouse.position" type="text"
								placeholder="Enter spouse position"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="12">
						<h4>Emergency Information</h4>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Emergency Contact Name">
							<ValidationProvider v-slot="{ errors }" :rules="{ name: true }" :vid="'spouseName'">
								<b-form-input v-model="form.emergency_contact.name" type="text"
									placeholder="Enter emergency contact name" required></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Relationship">
							<el-select v-model="form.emergency_contact.relationship" placeholder="Select">
								<el-option :value="null"></el-option>
								<el-option v-for="item in tables.relationship" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Contact Number">
							<ValidationProvider v-slot="{ errors }" :rules="{ number_only: true }" :vid="'number_only'">
								<b-form-input v-model="form.emergency_contact.contact_no" type="text" maxlength="17"
									placeholder="Enter Emergency contact number" @keydown="preventNonNumericInput">
								</b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Address">
							<ValidationProvider v-slot="{ errors }">
								<b-form-input v-model="form.emergency_contact.address" type="text"
									placeholder="Enter emergency's contact address " required></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-button block variant="primary" class="w-50" type="submit" :disabled="invalid">Save</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</div>
</template>
<script>
import { Select, Option } from 'element-ui';
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCommonStore } from '@/stores/commonStore';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js';
import { preventNonNumericInput } from '@/assets/js/formValidations.js'

export default {
	name: 'spouse-info-form',
	components: {
		ValidationObserver,
		ValidationProvider,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			form: {
				spouse: {
					name: '',
					nric: '',
					contact_no: '',
					company_name: '',
					position: '',
				},
				emergency_contact: {
					name: '',
					relationship: '',
					contact_no: '',
					address: '',
				}
			},
			tables: {
				relationship: [
					'Spouse',
					'Cousin',
					'Siblings',
					'Relative',
					'Parent',
					'Friend',
					'Others'
				],
			}
		}
	},
	created() {
		this.form.spouse = this.activeCustomer.spouse || {};
		this.form.emergency_contact = this.activeCustomer.emergency_contact || {};
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer']),
	},
	methods: {
		preventNonNumericInput,
		...mapActions(useCustomerStore, ['getCustomerIm2u', 'addSpouse', 'updateSpouse', 'addEmergency', 'updateEmergency']),
		...mapActions(useCommonStore, ['getTables']),
		getRelationship() {
			this.getTables('family_relationships').then(res => {
				this.tables.relationship = res.data;
			});
		},
		submit() {
			const spouseFunc = this.activeCustomer.spouse ? this.update(this.activeCustomer.spouse.customer_spouse_id) : this.create();
			const emergencyFunc = this.activeCustomer.emergency_contact ? this.updateEmrgncy(this.activeCustomer.emergency_contact.customer_emergency_id) : this.createEmrgncy();

			let calls = [
				spouseFunc,
				emergencyFunc
			];

			Promise.all(calls).then(responses => {
				console.log(responses);
				_gNotif.notifySuccess('<b>Spouse Information: ' + this.activeCustomer.name + '</b> - Successfully Updated.')
				this.getCustomerIm2u(this.activeCustomer.im2u_id)
			}).catch(e => {
			});
		},
		update(id) {
			this.updateSpouse(id, this.form.spouse);
		},
		create() {
			this.addSpouse(this.form.spouse);
		},
		updateEmrgncy(id) {
			this.updateEmergency(id, this.form.emergency_contact);
		},
		createEmrgncy() {
			this.addEmergency(this.form.emergency_contact);
		}
	}
}
</script>